module.exports = __webpack_public_path__ + "static/media/cloud.8f6e6534.png";